/**
 * Base API pour les médias (uploads) — évite les URLs relatives cassées depuis le front (port 3000).
 */
export function getApiBaseUrl() {
  if (process.env.REACT_APP_API_URL) {
    return String(process.env.REACT_APP_API_URL).replace(/\/$/, '');
  }
  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    if (port === '3000' || port === '') {
      return `${protocol}//${hostname}:8000`;
    }
  }
  return '';
}

/**
 * Transforme une URL stockée en URL absolue si besoin.
 */
export function resolveMediaUrl(url) {
  if (!url || typeof url !== 'string') return null;
  const u = url.trim();
  if (/^https?:\/\//i.test(u)) return u;
  const base = getApiBaseUrl();
  if (u.startsWith('/') && base) return `${base}${u}`;
  return u;
}

/**
 * Choisit la meilleure image affichable pour une carte restaurant (admin / listing).
 */
export function pickRestaurantImageUrl(restaurant) {
  if (!restaurant) return null;
  const prof = restaurant.profile || {};
  const fromProfile =
    prof.restaurant_image_url ||
    prof.card_image_url ||
    prof.banner_image_url ||
    prof.logo_url;
  if (fromProfile) return resolveMediaUrl(fromProfile);

  const imgs = restaurant.images;
  if (!Array.isArray(imgs) || imgs.length === 0) return null;

  const typeRank = (t) => {
    const order = { card: 0, restaurant: 1, banner: 2, logo: 3, slide: 4, gallery: 5 };
    return order[String(t || '').toLowerCase()] ?? 6;
  };

  const sorted = [...imgs].sort((a, b) => {
    if (a.is_primary && !b.is_primary) return -1;
    if (!a.is_primary && b.is_primary) return 1;
    const so = (a.sort_order ?? 0) - (b.sort_order ?? 0);
    if (so !== 0) return so;
    return typeRank(a.image_type) - typeRank(b.image_type);
  });

  for (const im of sorted) {
    if (im?.image_url) return resolveMediaUrl(im.image_url);
  }
  return null;
}
